import script from "./ChatHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ChatHeader.vue?vue&type=style&index=0&id=270d3736&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-270d3736"]])

export default __exports__